import { Configuration } from '@calm/evexia-web-sdk';
import { BaseAPI } from '@calm/evexia-web-sdk/generated/lib/base';
import { AxiosInstance } from 'axios';
import { browserClient } from './client/browser';

export const createApi = <T extends BaseAPI>(
    Api: new (
        config: Configuration,
        basePath?: string,
        axiosInstance?: AxiosInstance
    ) => T,
    accessToken: () => Promise<string>,
    /**
     * Sets a header keyed by the @param name to the value returned by the promise
     * See setApiKeyToObject() function @/libraries/evexia-web-sdk/generated/common.ts#L47-L47
     */
    apiKey?: (name: string) => Promise<string>,
    client: AxiosInstance = browserClient
): T => {
    return new Api(
        new Configuration({ accessToken, apiKey }),
        process.env.NEXT_PUBLIC_API_BASEURL,
        client
    );
};
